module.exports = __webpack_public_path__ + "static/media/phone-white.67d872d4.svg";